'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
export default class DropdownFormHeader extends PureComponent {
  render() {
    const {
      children,
      className,
      headerElement: HeaderElement
    } = this.props;
    const headerClasses = classNames('m-bottom-3', className);
    return /*#__PURE__*/_jsx("header", {
      className: headerClasses,
      children: /*#__PURE__*/_jsx(HeaderElement, {
        className: "m-bottom-0",
        children: children
      })
    });
  }

}
DropdownFormHeader.displayName = 'DropdownFormHeader';
DropdownFormHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  headerElement: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};
DropdownFormHeader.defaultProps = {
  children: null,
  className: '',
  headerElement: 'h5'
};